import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';


const SidebarContext = createContext({
})

export const useSidebarContext = () => useContext(SidebarContext);


export const SidebarProvider = ({ children }) => {
    const [actionbarContent, setActionbarContent] = useState(null)
    const [topbarContent, setTopbarContent] = useState(null)
    const [topbarTwoContent, setTopbarTwoContent] = useState(null)


    // const handleBackClick = useCallback(() => {
    //     if (backClickFunction) backClickFunction();
    // }, [backClickFunction]);


return (
        <SidebarContext.Provider value={{
            topbarContent,
            setTopbarContent,
            actionbarContent, setActionbarContent,
            topbarTwoContent, setTopbarTwoContent
        }}>
            {children}
        </SidebarContext.Provider>
    )
}